import {
    RESET_ADVERT_ACTION_STATE,
    RESET_ADVERT_STATE,
    CREATE_ADVERT,
    CREATE_ADVERT_SUCCESS,
    CREATE_ADVERT_FAIL,
    GET_ADVERT_LISTING,
    GET_ADVERT_LISTING_SUCCESS,
    GET_ADVERT_LISTING_FAIL,
    GET_COE_BIDDING_LIST,
    GET_COE_BIDDING_LIST_SUCCESS,
    GET_COE_BIDDING_LIST_FAIL,
    GET_ADVERT_DETAILS,
    GET_ADVERT_DETAILS_SUCCESS,
    GET_ADVERT_DETAILS_FAIL,
    UPDATE_ADVERT,
    UPDATE_ADVERT_SUCCESS,
    UPDATE_ADVERT_FAIL,
    DELETE_ADVERT,
    DELETE_ADVERT_SUCCESS,
    DELETE_ADVERT_FAIL,
    GET_ERP_LISTING,
    GET_ERP_LISTING_SUCCESS,
    GET_ERP_LISTING_FAIL,
    GET_ADVERT_REMARK_LISTING,
    GET_ADVERT_REMARK_LISTING_SUCCESS,
    GET_ADVERT_REMARK_LISTING_FAIL,
    GET_ADVERT_INQUIRY_LISTING,
    GET_ADVERT_INQUIRY_LISTING_SUCCESS,
    GET_ADVERT_INQUIRY_LISTING_FAIL,
    BULK_UPDATE_ADVERT_FAIL,
    BULK_UPDATE_ADVERT_SUCCESS,
    BULK_UPDATE_ADVERT,
    REQUEST_MAKE_MODEL,
    REQUEST_MAKE_MODEL_SUCCESS,
    REQUEST_MAKE_MODEL_FAIL,
    GET_ERP_DETAILS_SUCCESS,
    GET_ERP_DETAILS,
    GET_ERP_DETAILS_FAIL,
    REQUEST_SINGPASS_FAIL,
    REQUEST_SINGPASS_SUCCESS,
    REQUEST_SINGPASS,
    SET_ERP_DETAILS_LOCAL,
} from "./actionTypes";

export const getAdvertListing = (data) => ({
    type: GET_ADVERT_LISTING,
    payload: data,
});

export const getAdvertListingSuccess = data => ({
    type: GET_ADVERT_LISTING_SUCCESS,
    payload: data,
});

export const getAdvertListingFail = error => ({
    type: GET_ADVERT_LISTING_FAIL,
    payload: error,
});

export const getCoeBiddingList = (data) => ({
    type: GET_COE_BIDDING_LIST,
    payload: data,
});

export const getCoeBiddingListSuccess = data => ({
    type: GET_COE_BIDDING_LIST_SUCCESS,
    payload: data,
});

export const getCoeBiddingListFail = error => ({
    type: GET_COE_BIDDING_LIST_FAIL,
    payload: error,
});

export const getAdvertDetails = (data) => ({
    type: GET_ADVERT_DETAILS,
    payload: data,
});

export const getAdvertDetailsSuccess = data => ({
    type: GET_ADVERT_DETAILS_SUCCESS,
    payload: data,
});

export const getAdvertDetailsFail = error => ({
    type: GET_ADVERT_DETAILS_FAIL,
    payload: error,
});

export const getAdvertRemarkListing = (data) => ({
    type: GET_ADVERT_REMARK_LISTING,
    payload: data,
});

export const getAdvertRemarkListingSuccess = data => ({
    type: GET_ADVERT_REMARK_LISTING_SUCCESS,
    payload: data,
});

export const getAdvertRemarkListingFail = error => ({
    type: GET_ADVERT_REMARK_LISTING_FAIL,
    payload: error,
});

export const getAdvertInquiryListing = (data) => ({
    type: GET_ADVERT_INQUIRY_LISTING,
    payload: data,
});

export const getAdvertInquiryListingSuccess = data => ({
    type: GET_ADVERT_INQUIRY_LISTING_SUCCESS,
    payload: data,
});

export const getAdvertInquiryListingFail = error => ({
    type: GET_ADVERT_INQUIRY_LISTING_FAIL,
    payload: error,
});

export const getErpListing = (data) => ({
    type: GET_ERP_LISTING,
    payload: data,
});

export const getErpListingSuccess = data => ({
    type: GET_ERP_LISTING_SUCCESS,
    payload: data,
});

export const getErpListingFail = error => ({
    type: GET_ERP_LISTING_FAIL,
    payload: error,
});

export const getErpDetails = (data) => ({
    type: GET_ERP_DETAILS,
    payload: data,
});

export const getErpDetailsSuccess = data => ({
    type: GET_ERP_DETAILS_SUCCESS,
    payload: data,
});

export const getErpDetailsFail = error => ({
    type: GET_ERP_DETAILS_FAIL,
    payload: error,
});

export const createAdvert = (data) => ({
    type: CREATE_ADVERT,
    payload: data,
});

export const createAdvertSuccess = data => ({
    type: CREATE_ADVERT_SUCCESS,
    payload: data,
});

export const createAdvertFail = error => ({
    type: CREATE_ADVERT_FAIL,
    payload: error,
});

export const updateAdvert = (data) => ({
    type: UPDATE_ADVERT,
    payload: data,
});

export const updateAdvertSuccess = data => ({
    type: UPDATE_ADVERT_SUCCESS,
    payload: data,
});

export const updateAdvertFail = error => ({
    type: UPDATE_ADVERT_FAIL,
    payload: error,
});

export const bulkUpdateAdvert = (data) => ({
    type: BULK_UPDATE_ADVERT,
    payload: data,
});

export const bulkUpdateAdvertSuccess = data => ({
    type: BULK_UPDATE_ADVERT_SUCCESS,
    payload: data,
});

export const bulkUpdateAdvertFail = error => ({
    type: BULK_UPDATE_ADVERT_FAIL,
    payload: error,
});

export const requestMakeModel = (data) => ({
    type: REQUEST_MAKE_MODEL,
    payload: data,
});

export const requestMakeModelSuccess = data => ({
    type: REQUEST_MAKE_MODEL_SUCCESS,
    payload: data,
});

export const requestMakeModelFail = error => ({
    type: REQUEST_MAKE_MODEL_FAIL,
    payload: error,
});

export const deleteAdvert = (data) => ({
    type: DELETE_ADVERT,
    payload: data,
});

export const deleteAdvertSuccess = data => ({
    type: DELETE_ADVERT_SUCCESS,
    payload: data,
});

export const deleteAdvertFail = error => ({
    type: DELETE_ADVERT_FAIL,
    payload: error,
});

export const requestSingpass = (data) => ({
    type: REQUEST_SINGPASS,
    payload: data,
});

export const requestSingpassSuccess = data => ({
    type: REQUEST_SINGPASS_SUCCESS,
    payload: data,
});

export const requestSingpassFail = error => ({
    type: REQUEST_SINGPASS_FAIL,
    payload: error,
});

//reset
export const resetAdvertActionState = () => {
    return {
        type: RESET_ADVERT_ACTION_STATE,
    }
}
export const resetAdvertState = () => {
    return {
        type: RESET_ADVERT_STATE,
    }
}

//for setting local myinfo data 
export const setErpDetailsLocal = (data) => {
    return {
        type: SET_ERP_DETAILS_LOCAL,
        payload: data,
    };
};
